export default __webpack_public_path__ + "static/media/Microsoft.d03ffcfc.svg";